import { observer } from "mobx-react";
import styles from "./styles/FooterCS.module.scss";
import ClickableLink from "../utilities/ClickableLink";
import FontAwesome from "../utilities/FontAwesome";
import { convertFlatToTree } from "../../utils/DataUtilities";
import { isLink, isTopLevel } from "../modals/AdminModal/utilities";
import NavigationLink from "../header/navigation/NavigationLink";
import { isSchoolBlocksApp } from "../../utils/SchoolBlocksUtilities";
import { useStores } from "../../stores/useStores";
import { ReactNode } from "react";
import { Heading } from "@radix-ui/themes";

interface NavigationColumnProps {
  href: string;
  title: string;
  navigationTree: Navigation[];
}

const NavigationColumn: React.FC<NavigationColumnProps> = (props) => {
  const filteredNavigation = props.navigationTree.filter(
    (n) => isLink(n) && isTopLevel(n) && n.enabled,
  );

  if (filteredNavigation.length === 0) {
    return null;
  }

  return (
    <div className={styles.navColumn}>
      {props.title && (
        <Heading as={"h3"} size={"5"}>
          <ClickableLink href={props.href}>{props.title}</ClickableLink>
        </Heading>
      )}
      <ul>
        {filteredNavigation.map((n, idx) => (
          <li key={n.id || idx}>
            <NavigationLink navigationObj={n} title={n.title}>
              {n.icon && <FontAwesome ariaHidden={true} name={n.icon} />}{" "}
              {n.title}
            </NavigationLink>
          </li>
        ))}
      </ul>
    </div>
  );
};

const FooterNavColumn = observer(() => {
  const { organizationStore } = useStores();

  const columns: ReactNode[] = [];

  if (organizationStore.navigationTree.length > 0) {
    columns.push(
      <NavigationColumn
        key={"org-nav"}
        href={organizationStore.organization.url}
        title={
          organizationStore.organization.type === "organization"
            ? undefined
            : organizationStore.organization.type
        }
        navigationTree={organizationStore.navigationTree.filter(
          (n) => !n.is_district_link,
        )}
      />,
    );
  }

  if (
    organizationStore.organization.type === "school" &&
    organizationStore.organization.parent_id !== "root" &&
    isSchoolBlocksApp()
  ) {
    const districtOrg = organizationStore.organization.district;
    if (districtOrg?.navigation?.length > 0) {
      const districtLink = organizationStore.navigationTree.find(
        (n) => n.is_district_link,
      )?.url;
      columns.unshift(
        <NavigationColumn
          key={"district-nav"}
          href={districtLink}
          title={"DISTRICT"}
          navigationTree={convertFlatToTree(districtOrg.navigation)}
        />,
      );
    }
  }

  return <>{columns}</>;
});

export default FooterNavColumn;
